import { IReferralConfig } from '@nkr/models/index';
import { IValidation } from './validation';
import { Col, ControlLabel, FormControl, FormGroup, Panel, Radio } from 'react-bootstrap'

interface IProps {
    data: IReferralConfig,
    validation: IValidation,
    dirty: boolean,
    onRadioChange: (e: React.FormEvent<Radio & HTMLInputElement>) => void,
    onDataChange: (e: React.FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => void
}

const KidneyDonorsOnly = (props: IProps) => {
    return (
        <Panel>
            <Panel.Heading>Kidney Donors Only</Panel.Heading>
            <Panel.Body>
                <FormGroup validationState={props.dirty && !props.validation.donorMaxAge ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Max age for kidney donor?</Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            type="text"
                            id="donorMaxAge"
                            placeholder='0 to 255'
                            style={{ width: 300 }}
                            value={props.data.donorMaxAge}
                            onChange={props.onDataChange}
                        />
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.bmiLimit ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Max BMI for work-up?</Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            type="text"
                            id="bmiLimit"
                            style={{ width: 300 }}
                            value={props.data.bmiLimit}
                            onChange={props.onDataChange}
                        />
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.bmiRequiredForSurgery ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Max BMI for surgery?</Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            type="text"
                            id="bmiRequiredForSurgery"
                            style={{ width: 300 }}
                            value={props.data.bmiRequiredForSurgery}
                            onChange={props.onDataChange}
                        />
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.ruleOutOnKidneyDisease ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Rule out on kidney disease?</Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='ruleOutOnKidneyDisease' value={1} checked={props.data.ruleOutOnKidneyDisease != null ? props.data.ruleOutOnKidneyDisease : false} onChange={props.onRadioChange}>Yes</Radio>
                        <Radio inline name='ruleOutOnKidneyDisease' value={0} checked={props.data.ruleOutOnKidneyDisease != null ? !props.data.ruleOutOnKidneyDisease : false} onChange={props.onRadioChange}>No</Radio>
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.diabetesFailLevel ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Rule out on Diabetes?</Col>
                    <Col xs={12} lg={5}>
                        <FormControl
                            componentClass='select'
                            name='diabetesFailLevel'
                            id="diabetesFailLevel"
                            value={props.data.diabetesFailLevel}
                            onChange={props.onDataChange}
                        >
                            <option key={'diab-' + 1} value={1}>Always</option>
                            <option key={'diab-' + 2} value={2}>Only if on medication or insulin</option>
                            <option key={'diab-' + 3} value={3}>Only if on insulin</option>
                        </FormControl>
                    </Col>
                </FormGroup>
            </Panel.Body>
        </Panel>
    );
}

export default KidneyDonorsOnly;